import { useState, useEffect } from "react";
import { Grid, MenuItem, Select, FormControl, Button } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { escapeRegExp } from "../../utils";
import LeaveService from "../../services/LeaveService";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import DirectionService from "../../services/DirectionService";
import FileService from "../../services/FileService";
import * as FileSaver from "file-saver";
import { userDetailContext } from "../../App";
import { useContext } from "react";
import { hasPrivilege } from "../../utils/privilege";
import AnalyticsIcon from '@mui/icons-material/Analytics';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { CircularProgress } from '@mui/material';
import Message from "../tools/Message";
import MainContainer from "../../components/MainContainer";
import { headerEtat } from "../../data/modules/etat_header";
import { Alert } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import UserService from "../../services/UserService"; // <-- AJOUTÉ : Import manquant

function MonthlyReport(props) {
    const contextData = useContext(userDetailContext);
    
    const getYearRange = () => {
        const currentYear = new Date().getFullYear();
        const startYear = 2024;
        const years = [];
        for (let year = startYear; year <= currentYear; year++) {
            years.push(year);
        }
        return years;
    };

    const getAvailableMonths = (selectedYear) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        
        if (selectedYear === currentYear) {
            return Array.from({ length: currentMonth }, (_, i) => i + 1);
        }
        return Array.from({ length: 12 }, (_, i) => i + 1);
    };

    const years = getYearRange();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    
    const [dir, setDir] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [rows, setRows] = useState([]);
    
    // États pour les valeurs sélectionnées (UI)
    const [selectedMonth, setSelectedMonth] = useState(() => {
        const currentMonth = new Date().getMonth() + 1;
        return currentMonth;
    });

    const [selectedYear, setSelectedYear] = useState(() => {
        return new Date().getFullYear();
    });
    const [selectedDirection, setSelectedDirection] = useState(1);
    
    // États pour les valeurs filtrées (utilisées pour les requêtes API)
    const [filteredMonth, setFilteredMonth] = useState(() => {
        const currentMonth = new Date().getMonth() + 1;
        return currentMonth;
    });

    const [filteredYear, setFilteredYear] = useState(() => {
        return new Date().getFullYear();
    });
    const [filteredDirection, setFilteredDirection] = useState(1);

    const getPreviousMonthData = () => {
        const today = new Date();
        let year = today.getFullYear();
        let month = today.getMonth(); 

        // Si on est en janvier
        if (month === 0) {
            month = 11; 
            year = year - 1; 
        } else {
            month = month - 1;
        }

        return { year, month: month + 1 };
    };

    const previousDate = getPreviousMonthData();
    
    const [loading, setLoading] = useState(false);
    const [loadingrapport, setLoadingapport] = useState(false);
    const [filterLoading, setFilterLoading] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
    });
    const { open, color, messageInfo } = message;
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [availableMonths, setAvailableMonths] = useState([]);

    // Fonction pour charger les données avec les valeurs filtrées
    const loadTable = (currentMonth, currentDirectionId, currentYear) => {
        setOpenLoadingSimpleBackdrop(true);
        
        LeaveService.getMonthlyReportForAllUser(currentMonth, currentDirectionId, currentYear)
            .then((result) => {
                if (result && result.status) {
                    setRows(result.data.map((row, index) => ({ ...row, id: index })));
                } else {
                    setRows([]);
                }
                setOpenLoadingSimpleBackdrop(false);
            })
            .catch((error) => {
                console.error("Error loading table:", error);
                setRows([]);
                setOpenLoadingSimpleBackdrop(false);
                setMessage({ 
                    ...message, 
                    open: true, 
                    color: 'red', 
                    messageInfo: "Erreur lors du chargement des données" 
                });
            });
    };

    // Filtrer les données avec le bouton - envoie la requête avec les valeurs sélectionnées
    const handleFilter = () => {
        setFilterLoading(true);
        
        // Mettre à jour les valeurs filtrées avec les valeurs sélectionnées
        setFilteredMonth(selectedMonth);
        setFilteredYear(selectedYear);
        setFilteredDirection(selectedDirection);
        
        // Appeler l'API avec les nouvelles valeurs
        loadTable(selectedMonth, selectedDirection, selectedYear);
        
        setTimeout(() => {
            setFilterLoading(false);
            setMessage({ 
                ...message, 
                open: true, 
                color: 'green', 
                messageInfo: "Filtre appliqué avec succès" 
            });
        }, 500);
    };

    // Submit avec le bouton Filtrer
    const handleSubmit = () => {
        loadTable(selectedMonth, selectedDirection, selectedYear);
    };

    // Charger les directions au montage du composant
    useEffect(() => {
        const userData = localStorage.getItem('USER');
        if (userData) {
            UserService.getUserSummaryByUserId(userData)
                .then((result) => {
                    if (result && result.data) {
                        const dirpers = result.data.direction_id;
                        // setUserDirectionId(dirpers); // Variable non définie - commentée
                        DirectionService.getDirection().then((directionResult) => {
                            if (directionResult && directionResult.data) {
                                // setAllDirections(directionResult.data); // Variable non définie - commentée
                                
                                if (parseInt(dirpers, 10) === 1) {
                                    setDir(directionResult.data); // CORRIGÉ : Utilisation de directionResult.data au lieu de res.data
                                    setSelectedDirection(1);
                                    setFilteredDirection(1);
                                } else {
                                    const userDirection = directionResult.data.filter(
                                        ts => parseInt(ts.direction_id, 10) === parseInt(dirpers, 10)
                                    );
                                    // setDirection(userDirection); // Variable non définie - commentée
                                    setDir(userDirection); // CORRIGÉ : Utilisation de setDir pour stocker la direction de l'utilisateur
                                    
                                    if (userDirection.length > 0) {
                                        setSelectedDirection(userDirection[0].direction_id); // CORRIGÉ : Accès à direction_id
                                        // setFilter((prev) => ({ ...prev, direction: dirpers })); // Variable 'setFilter' non définie - commentée
                                    }
                                }
                            }
                        });
                    }
                });
        }
    }, []); // CORRIGÉ : Ajout des dépendances vides

    // Mettre à jour les mois disponibles quand l'année sélectionnée change
    useEffect(() => {
        const months = getAvailableMonths(selectedYear);
        setAvailableMonths(months);
        
        // Si le mois sélectionné n'est pas disponible, prendre le dernier mois disponible
        if (!months.includes(selectedMonth)) {
            setSelectedMonth(months[months.length - 1]);
        }
    }, [selectedYear]);

    // Chargement initial au montage du composant
    useEffect(() => {
        if (selectedDirection && selectedMonth && selectedYear) {
            loadTable(selectedMonth, selectedDirection, selectedYear);
            setFilteredMonth(selectedMonth);
            setFilteredYear(selectedYear);
            setFilteredDirection(selectedDirection);
        }
    }, []); // CORRIGÉ : Dépendances vides pour exécution unique

    const requestSearch = (searchValue) => {
        setSearchText(searchValue);
        if (!searchValue || searchValue === "") {
            // Recharger les données originales si la recherche est vide
            loadTable(filteredMonth, filteredDirection, filteredYear);
            return;
        }
        
        const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
        const filteredRows = [...rows].filter((row) => {
            return Object.keys(row).some((field) => {
                return row[field] && searchRegex.test(row[field].toString());
            });
        });
        setRows(filteredRows.map((row, index) => ({ ...row, id: index })));
    };

    function handleClickExport() {
        setLoading(true);
        LeaveService.doExport("monthly_report", selectedMonth, selectedYear, rows, selectedDirection)
            .then((res) => {
                if (res && res.status) {
                    const filenameResult = res.data;
                    FileService.readExcelFileContent("Leaves", filenameResult)
                        .then((result) => {
                            if (result && result.status) {
                                const data = new Blob([result.data], { type: fileType });
                                FileSaver.saveAs(data, filenameResult);
                                setMessage({ ...message, open: true, color: 'green', messageInfo: "Export réussi" });
                                setLoading(false);
                            } else {
                                setLoading(false);
                                setMessage({ ...message, open: true, color: 'red', messageInfo: "Erreur de téléchargement en Excel. Veuillez réessayer" });
                            }
                        });
                } else {
                    setLoading(false);
                    setMessage({ ...message, open: true, color: 'red', messageInfo: "Export non effectué, données encore non définies" });
                }
            })
            .catch(() => {
                setLoading(false);
                setMessage({ ...message, open: true, color: 'red', messageInfo: "Erreur lors de l'export" });
            });
    }

    function handleClickExportrapport() {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        
        // Vérifier si le mois demandé est le mois courant ou un mois antérieur
        if (filteredYear > currentYear || (filteredYear === currentYear && filteredMonth > currentMonth)) {
            setMessage({ 
                ...message, 
                open: true, 
                color: 'red', 
                messageInfo: "Vous ne pouvez générer un rapport que pour le mois en cours ou les mois antérieurs" 
            });
            return;
        }
        
        setLoadingapport(true);
        LeaveService.doExportraaportmensuel("monthly_report", selectedMonth, selectedYear, rows, selectedDirection)
            .then((res) => {
                if (res && res.status) {
                    setLoadingapport(false);
                    setMessage({ ...message, open: true, color: 'green', messageInfo: "Merci de vérifier votre boîte mail pour le rapport mensuel." });
                } else {
                    setLoadingapport(false);
                    setMessage({ ...message, open: true, color: 'red', messageInfo: "Export non effectué, données encore non définies" });
                }
            })
            .catch(() => {
                setLoadingapport(false);
                setMessage({ ...message, open: true, color: 'red', messageInfo: "Erreur lors de l'envoi du rapport" });
            });
    }

    function handleChangeMonth(ev) {
        const monthSelected = ev.target.value;
        setSelectedMonth(monthSelected);
    }
    
    function handleChangeYear(ev) {
        const yearSelected = ev.target.value;
        setSelectedYear(yearSelected);
    }

    function handleChangeDirection(event) {
        const value = event.target.value;
        setSelectedDirection(value);
    }

    function handleCloseMessage() {
        setMessage({ ...message, open: false });
    }

    const monthNames = {
        1: 'Janvier', 2: 'Février', 3: 'Mars', 4: 'Avril',
        5: 'Mai', 6: 'Juin', 7: 'Juillet', 8: 'Août',
        9: 'Septembre', 10: 'Octobre', 11: 'Novembre', 12: 'Décembre'
    };

    const column = [
        {
            field: 'matricule',
            headerName: 'Matricule',
            width: 150,
        },
        {
            field: 'direction_code',
            headerName: 'Direction',
            width: 150,
        },
        {
            field: 'name',
            headerName: 'Nom et Prénoms',
            width: 300,
        },
        {
            field: 'function_name',
            headerName: 'Poste actuel',
            width: 300,
        },
        {
            field: 'leave_begin',
            headerName: 'Congé mois d\'avant',
            width: 300,
        },
        {
            field: 'leaveTaken',
            headerName: 'Congé consommé',
            width: 200,
        },
        {
            field: 'real_balance',
            headerName: 'Solde congé fin du mois',
            width: 250,
        },
        {
            field: 'funding',
            headerName: 'Financement',
            width: 200,
        },
        {
            field: 'service_name',
            headerName: 'Direction/Service',
            width: 250,
        },
    ];

    // Vérifier si le bouton rapport mensuel doit être désactivé
    const isReportDisabled = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        return (filteredYear === currentYear && filteredMonth > currentMonth);
    };

    return (
        <MainContainer {...headerEtat}>
            <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
            <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
            <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                    <Alert severity="info">
                        Choisissez le mois et l’année, puis cliquez sur « Filtrer » pour afficher les résultats.<br />
                        Note : les rapports de plus d’un mois sont uniquement consultables et ne peuvent plus être téléchargés.
                    </Alert>
                </Grid>

                 <Grid item xs={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        startIcon={<SearchIcon />}
                        style={{ fontWeight: 800, width: 170 }}
                    >
                        Filtrer
                    </Button>
                </Grid>
                <Grid item xs={2}>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleFilter}
                        disabled={filterLoading}
                        startIcon={filterLoading ? <CircularProgress size={20} /> : <FilterAltIcon />}
                        style={{ fontWeight: 600 }}
                    >
                        {filterLoading ? 'Chargement...' : 'Appliquer filtre'}
                    </Button>
                </Grid>

                 {/* Boutons d'export standards (pour tous les mois) - affichés si ce n'est pas le mois précédent */}
                {rows.length > 0 && 
                 !(filteredYear === previousDate.year && filteredMonth === previousDate.month) ? (
                    <>
                        <Grid item xs={2}>
                            <Button
                                variant="contained"
                                onClick={handleClickExport}
                                style={{ fontWeight: 600 }}
                                disabled={loading}
                                startIcon={loading ? <CircularProgress size={24} color="inherit" /> : null}
                            >
                                {loading ? 'Chargement...' : 'EXPORTER'}
                            </Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={handleClickExportrapport} 
                                style={{ fontWeight: 800 }}
                                disabled={loadingrapport || isReportDisabled()}
                                startIcon={loadingrapport ? <CircularProgress size={24} color="inherit" /> : <AnalyticsIcon />}
                                title={isReportDisabled() ? "Rapport disponible uniquement pour le mois en cours ou antérieur" : ""}
                            >
                                {loadingrapport ? 'Chargement...' : 'Rapport mensuel'}
                            </Button>
                        </Grid>
                        <Grid item xs={4}>
                            {/* Espace pour l'alignement */}
                        </Grid>
                    </>
                   ) : (
                    <Grid item xs={8}></Grid>
                 )}

           

                {/* Ligne des filtres */}
                <Grid item xs={3}>
                    <FormControl fullWidth variant="outlined" size="small">
                        <Select
                            labelId="year-select-label"
                            value={selectedYear}
                            name="year"
                            onChange={handleChangeYear}
                        >
                            {years.map((yearOption, index) => (
                                <MenuItem key={index} value={yearOption}>
                                    {yearOption}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={3}>
                    <FormControl fullWidth variant="outlined" size="small">
                        <Select 
                            value={selectedMonth} 
                            name="month" 
                            onChange={handleChangeMonth}
                        >
                            {availableMonths.map((monthValue) => (
                                <MenuItem key={monthValue} value={monthValue}>
                                    {monthNames[monthValue]}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={3}>
                    <FormControl fullWidth variant="outlined" size="small">
                        <Select 
                            value={selectedDirection} 
                            name="direction_id" 
                            onChange={handleChangeDirection}
                        >
                            {dir.map((row) => (
                                <MenuItem key={row.direction_id} value={row.direction_id}>
                                    {row.code}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
               

                {/* Tableau des résultats */}
                <Grid item xs={12}>
                    <div style={{ height: "70vh", width: "100%" }}>
                        <DataGrid
                            columns={column}
                            rows={rows}
                            pageSize={10}
                            rowsPerPageOptions={[10, 25, 50]}
                            disableSelectionOnClick
                            componentsProps={{
                                toolbar: {
                                    value: searchText,
                                    onChange: (event) => requestSearch(event.target.value),
                                    clearSearch: () => requestSearch(""),
                                },
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
        </MainContainer>
    );
}

export default MonthlyReport;